<template>
<div class="izk-qq">
	<!-- Start 群标题 -->
    <div class="izk-qq-head">
        <!-- Start 通用返回 -->
        <nav class="izk-back">
            <a href="javascript:;" class="hbox" v-on:click="back">
                <i class="ico-back-white ti">返回</i>
            </a>
        </nav>
        <h2 class="title te">{{content.g_name}}</h2>
        <p class="info">{{content.g_phrase}}</p>
    </div>
    <!-- Start 群标题 -->

    <!-- Start 群介绍 -->
    <section class="izk-qq-info">
        <h3 class="izk-qq-title">群介绍</h3>
        <p class="info">
            {{content.finger_memo}}
        </p>
        <ul class="izk-qq-tag">
            <li v-for="item in content.g_tags">{{item.tag_name}}</li>
        </ul>
    </section>
    <section class="izk-qq-member">
        <h3 class="izk-qq-title">群成员</h3>
        <!-- 点击展开 加上类 unfold-->
        <div class="izk-qq-avatar">
            <ul class="jlcbox">
                <li v-for="item in content.members_face">
                    <img :src="item" alt=""/>
                </li>

            </ul>
            <a href="javascript:;" class="izk-ellipsis cwbox">
                <i></i>
                <i></i>
                <i></i>
            </a>
        </div>

    </section>
    <!-- End 群介绍 -->

    <div class="izk-fix-qq cbox">
        <a href="javascript:void(0)" @click='goNow' class="g-btn1" ><i class="ico-loading" v-if="isUse"></i>立即加入</a>
    </div>
</div>
</template>
<script>
	import '@/components/common/css/course/qq.css';
import api from '../../../common/libs/api.js';
import {mapState} from 'vuex';
import CallApp from 'callapp-lib';

	export default{
	  name: 'Qq',
	  data() {
	    return {
      content: {
        g_tags: [{}],
        members_face: []
      },
      go: 'mqqapi://card/show_pslcard?src_type=internal&version=1&card_type=group&uin=',
      download: "http://sj.qq.com/myapp/detail.htm?apkName=com.tencent.mobileqq",
      isUse: false
	    }
	  },
  computed: mapState({
    city: state => state.home.city
  }),
  methods: {
    goNow() {
      let vm = this;
      vm.isUse = true;

      let stater = this.$store.state;
      let obj = {
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级',
        'group_name': this.content.g_name
      }

      utils.bury('yd_izhikang_qq_group_join', obj);


      window.location.href = vm.go;

      setTimeout(function() {
        window.location.href = vm.download;
        vm.isUse = false;
      }, 4000);
    },
    getQqDetail() {
      let vm = this;
      let obj = {
        city: this.city.city_code,
        group_id: this.$route.query.group_id
      };

      api.apiMethod.getQqDetail.post(obj).then(res => {

        if (res.data.errid == 0) {
          vm.content = res.data.content;
          vm.go += this.content.group_openid;
        }
      })
    },
    back() {
      this.$router.go(-1);
    },
    join() {

      //mqq://im/chat?chat_type=wpa&uin=139966056&version=1&src_type=web
      //mqqwpa://im/chat?chat_type=wpa&uin=您的qq号&version=1&src_type=web&web_src=oicqzone.com
      //mqqwpa://im/chat?chat_type=wpa&uin=您的qq号&version=1&src_type=web&web_src=oicqzone.com
      const callapp = new CallApp(options);

      callapp.open({
        param: {
          src_type: 'internal',
          version: 1,
          card_type: 'group',
          uin: this.content.group_openid
        },
        path: 'card/show_pslcard'
      })
    }
  },
	  mounted() {
    this.getQqDetail();
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
	  }
	}

const options = {
  protocol: 'mqqapi://',
  intent: {
    package: '',
    scheme: ''
  },
  appstore: 'https://itunes.apple.com/cn/app/qq/id444934666',
  yingyongbao: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.mobileqq&fromcase=40002',
  fallback: 'http://dev-www.izhikang.com/h5/#/'
}
</script>








// WEBPACK FOOTER //
// src/components/public/qq/Qq.vue